/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Asset Route Icon.
 */
export const RouteIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <ThemeIconProvider name='RouteIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.30571 2.63086H16.4205C17.557 2.63086 18.647 3.08237 19.4506 3.886C20.2542 4.68964 20.7057 5.77961 20.7057 6.91612C20.7069 7.47921 20.597 8.03698 20.3821 8.55745C20.1672 9.07793 19.8516 9.55086 19.4534 9.94903C19.0552 10.3472 18.5824 10.6628 18.0619 10.8777C17.5414 11.0926 16.9836 11.2026 16.4205 11.2013H11.217H6.00395C4.86821 11.2038 3.77972 11.6561 2.97664 12.4592C2.17355 13.2623 1.72128 14.3508 1.71875 15.4865C1.71875 16.623 2.1702 17.713 2.97383 18.5166C3.77747 19.3203 4.86744 19.7718 6.00395 19.7718H18.697" stroke="#828282" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <circle cx="20.6101" cy="19.6091" r="1.6413" stroke="#828282" strokeWidth="1.5"/>
        <circle cx="3.3913" cy="2.3913" r="1.6413" stroke="#828282" strokeWidth="1.5"/>
      </svg>
    )} />
  );
};
